class customSelect extends HTMLElement {
  constructor() {
    super();

    this.combobox = this.querySelector('[role=combobox]');
    this.clickedInput = this.querySelector('.clicked-input');
    this.selectedText = this.querySelector('.selected-text');
    this.selectedOpenText = this.querySelector('.selected-open-text');
    this.textFooter = this.querySelector('.text-footer');
    this.altTextFooter = document.querySelector(`.text-footer-${this.dataset.textFooter}`)

    if(this.dataset.textFooter && this.altTextFooter){
      this.textFooter = this.altTextFooter.querySelector(".element-text");
    }

    this.listbox = this.querySelector('[role=listbox]');
    this._options = [];
    if (this.listbox) {
      this._options = this.listbox.querySelectorAll('.selectCustom-option');
      this._currentOption = this.listbox.querySelector('[aria-selected=true]') || this.options[0];
    }

    if (this.combobox) {
      this.combobox.addEventListener('click', (e) => {
        this.closeDropdown(e);
      });
    }

    this.clickedInput.addEventListener('click', (e) => {
      this.closeDropdown(e);
    });

    const self = this;
    if (this._options.length > 0) {
      this._options.forEach((option) => {
        option.addEventListener('click', () => {
          self.currentOption = option;
          this.close();
        });
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!this.isExpanded) return;

      self.handleKeypresses(e);
    });

    document.addEventListener('click', (e) => {
      if (!this.isExpanded) return;

      self.handleBodyClick(e);
    });
  }

  closeDropdown() {
    if (this.isExpanded) this.close();
    else this.open();
  }

  get isExpanded() {
    if (!this.combobox) return false;

    return this.combobox.getAttribute('aria-expanded') == 'true';
  }

  get currentOptionIndex() {
    return Array.from(this.options).findIndex((option) => option === this.currentOption);
  }

  get options() {
    return Array.from(this._options).filter((option) => !option.hasAttribute('aria-hidden'));
  }

  get currentOption() {
    return this._currentOption;
  }

  set currentOption(option) {
    if (!option) return;

    this.unselectAllOptions();

    this._currentOption = option;

    option.setAttribute('aria-selected', true);

    if (this.combobox) {
      this.combobox.setAttribute('aria-activedescendant', option.getAttribute('id'));
    }

    this.dataset.value = option.dataset.value;

    this.setOption(this.selectedText, this.selectedOpenText, option);

    this.triggerEvent();
  }

  setOption(selectedText, selectedOpenText, option) {
    if (!option) return;

    const valueElement = option.querySelector('.value');

    let innerHTML = '';
    let textContent = '';
    if (valueElement) {
      innerHTML = valueElement.innerHTML;
      textContent = valueElement.textContent;
    }

    if ('textFooter' in option.dataset && this.textFooter) {
      this.textFooter.innerHTML = option.dataset.textFooter || '';
    } else if (this.textFooter) {
      this.textFooter.innerHTML = textContent;
    }

    if (selectedText) selectedText.innerHTML = innerHTML;
    if (selectedOpenText) selectedOpenText.innerHTML = innerHTML;
  }

  handleKeypresses(e) {
    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault();
        this.selectPreviousOption();

        break;

      case 'ArrowDown':
        e.preventDefault();
        this.selectNextOption();

        break;

      case 'Escape':
      case 'Enter':
        if (this.isExpanded) {
          e.preventDefault();

          this.close();
        }

        break;
    }
  }

  handleBodyClick(e) {
    if (!this.contains(e.target) && this.isExpanded) this.close();
  }

  showAllOptions() {
    this._options.forEach((option) => {
      option.removeAttribute('aria-hidden');
    });
  }

  unselectAllOptions() {
    this._options.forEach((option) => {
      option.removeAttribute('aria-selected');
    });
  }

  selectNextOption() {
    this.currentOption =
      this.currentOptionIndex + 1 < this.options.length ? this.options[this.currentOptionIndex + 1] : this.options[0];
  }

  selectPreviousOption() {
    this.currentOption =
      this.currentOptionIndex - 1 >= 0
        ? this.options[this.currentOptionIndex - 1]
        : this.options[this.options.length - 1];
  }

  open() {
    this.setAttribute('aria-hidden', false);
    this.combobox.setAttribute('aria-expanded', true);

    if (this.currentOption) this.currentOption.focus();

    this.triggerEvent('open');
  }

  close() {
    this.setAttribute('aria-hidden', true);

    if (this.combobox) {
      this.combobox.setAttribute('aria-expanded', false);
    }

    this.triggerEvent('close');
  }

  triggerEvent(event = 'change') {
    this.dispatchEvent(new Event(event));
  }

  setFirstAvailableOption() {
    this.currentOption = this.options[0];
  }
}

if (!customElements.get('custom-dropdown')) {
  customElements.define('custom-dropdown', customSelect);
}

if (!customElements.get('material-dropdown')) {
  customElements.define(
    'material-dropdown',
    class materialSelect extends customSelect {
      constructor() {
        super();
      }

      set currentOption(option) {
        this.unselectAllOptions();

        this._currentOption = option;

        option.setAttribute('aria-selected', true);

        this.dataset.id = option.id;
        this.dataset.value = option.dataset.value;
        this.dataset.quality = option.dataset.quality;

        if (this.textFooter) this.textFooter.innerHTML = option.dataset.value;

        this.triggerEvent();
      }

      get isExpanded() {
        return null;
      }

      closeDropdown() {}

      setOption() {}
    },
  );
}

if (!customElements.get('quantity-dropdown')) {
  customElements.define(
    'quantity-dropdown',
    class quantitySelect extends customSelect {
      constructor() {
        super();

        if (this.dataset.form) {
          this.inputQty = document.querySelector(`#${this.dataset.form} [name="quantity"]`);
        }

        this.input = this.querySelector('.input');
        if (this.input) {
          this.input.addEventListener('input', (e) => {
            this.unselectAllOptions();
            this.validationInputByOption(this.input.value);
          });
        }
      }

      setOption(selectedText, selectedOpenText, option) {
        const valueElement = option.querySelector('.value');

        let innerHTML = '';
        if (valueElement) {
          innerHTML = valueElement.innerHTML;
        }

        if (selectedText) selectedText.innerHTML = innerHTML;
        if (selectedOpenText) selectedOpenText.innerHTML = innerHTML;

        if (this.input) this.input.value = option.dataset.value;

        if (this.inputQty) {
          this.inputQty.value = option.dataset.value;
          this.inputQty.dispatchEvent(new Event('change', {bubbles: true}));
        }
      }

      validationInputByOption(value) {
        let tempOption = this.options.find((option) => option.dataset.value == value);

        if (tempOption) {
          this.currentOption = tempOption;
        } else {
          this.setValue(value);
        }
      }

      closeDropdown(e) {
        if (e.target.classList.contains('input')) return;

        if (this.isExpanded) this.close();
        else this.open();
      }

      setInput() {
        if (!this.inputQty) return;

        this.inputQty.value = this.dataset.value;
        this.inputQty.dispatchEvent(new Event('change', {bubbles: true}));
      }

      get currentOption() {
        return this._currentOption;
      }

      set currentOption(option) {
        if (!option) return;

        this.unselectAllOptions();

        this._currentOption = option;

        option.setAttribute('aria-selected', true);

        this.combobox.setAttribute('aria-activedescendant', option.getAttribute('id'));

        this.setValue(option.dataset.value);
      }

      // customQty(qtyField){
      //   const valueDropdown = qtyField;
      //   const ariaLabelledBy = valueDropdown.getAttribute('aria-labelledby');
      //   const qtySelectedTextId = ariaLabelledBy.split(' ').find(id => id === 'qty-selected-text');

      //   if(qtySelectedTextId === 'qty-selected-text'){
      //     const inputNumber = document.createElement('input');
      //     const valueQty = valueDropdown.querySelector('.value-dropdown');

      //     inputNumber.type = 'number';
      //     inputNumber.value = valueQty.textContent;

      //     inputNumber.style.width = '100%';
      //     inputNumber.style.border = 'none';
      //     inputNumber.style.backgroundColor = 'transparent';

      //     valueQty.replaceWith(inputNumber);
      //     valueQty.dispatchEvent(new Event('input'));
      //   }
      // }

      setValue(value) {
        this.dataset.value = value;

        const innerHTML = `<b class="value-dropdown">${value}</b>`;
        this.selectedText.innerHTML = innerHTML;
        this.selectedOpenText.innerHTML = innerHTML;

        if (this.input) {
          this.input.value = value;
        }

        // console.log("abiertoo3", this.combobox);
        // this.customQty(this.combobox);

        this.setInput();
        this.triggerEvent();
      }
    },
  );
}

if (!customElements.get('package-dropdown')) {
  customElements.define(
    'package-dropdown',
    class packageSelect extends customSelect {
      constructor() {
        super();

        if (this.dataset.form) {
          this.inputQty = document.querySelector(`#${this.dataset.form} [name="quantity"]`);
        }

        this.dropdownQty = document.querySelector('quantity-dropdown');
        this.unitByPackages = document.querySelectorAll('.unit-for-package');
      }

      get caseQty() {
        let caseQty = 1;

        let options = [];
        if (this.dropdownQty && this.dropdownQty.options) {
          options = this.dropdownQty.options;
        }

        if (options.length > 0) {
          const selectedOption = options[options.length - 1];

          if (selectedOption && selectedOption.dataset.value) {
            caseQty = selectedOption.dataset.value;
          }
        }

        return caseQty;
      }

      set currentOption(option) {
        if (!option) return;

        this.unselectAllOptions();

        this._currentOption = option;

        option.setAttribute('aria-selected', true);

        this.combobox.setAttribute('aria-activedescendant', option.getAttribute('id'));

        this.dataset.value = option.dataset.value;

        this.selectedText.innerHTML = option.querySelector('.value').innerHTML;
        this.selectedOpenText.innerHTML = option.querySelector('.value').innerHTML;

        if (this.inputQty && this.dropdownQty) {
          this.setPackageUnits();

          this.inputQty.value = this.dataset.value * this.caseQty;
          this.inputQty.dispatchEvent(new Event('change', {bubbles: true}));
        }

        this.triggerEvent();
      }

      setPackageUnits() {
        let maxQuantity = document.querySelector('variant-selects')
        this.unitByPackages.forEach((item) => {
          item.textContent = this.caseQty;
          if(maxQuantity){
            item.textContent = maxQuantity.maxQuantity;
          }

          if(maxQuantity.fakeQty) {
            item.textContent = maxQuantity.fakeQty;
          }
        });
      }
    },
  );
}

if (!customElements.get('size-dropdown')) {
  customElements.define(
    'size-dropdown',
    class sizeSelect extends customSelect {
      constructor() {
        super();

        const tabs = document.querySelectorAll('.content-tab-size');
        const contentTabs = document.querySelectorAll('.material-size');
        this.form = this.querySelector('form.custom-size');
        this.designOnline = document.querySelector('design-online');
        this.VariantSelects = document.querySelector('variant-selects');

        if (tabs.length > 0) {
          tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
              e.preventDefault();
              if (tab.classList.contains('active')) return;
              tabs.forEach((tab) => {
                tab.classList.remove('active');
              });
              tab.classList.add('active');
              contentTabs.forEach((contentTab) => {
                if (contentTab.classList.contains('active')) {
                  contentTab.classList.remove('active');
                } else {
                  contentTab.classList.add('active');
                }
                if (tab.dataset.type == 'custom') {
                  this.designOnline.classList.toggle('button-disable', !this.isValidCustomSize);
                  this.dataset.value = this.querySelector('[aria-selected="true"]').dataset.value;
                  this.dataset.value = this.querySelector('.content-tab-size.active').dataset.type;
                  this.save();
                } else {
                  this.designOnline.classList.toggle('button-disable', false);
                  this.removeAttribute('data-custom-value');
                  this.dataset.value = this.querySelector('[aria-selected="true"]').dataset.value;
                }

                this.dispatchEvent(new Event('change', {bubbles: true}));

                if (this.VariantSelects) {
                  this.VariantSelects.renderProductInfo();
                  this.VariantSelects.onVariantChange();
                }
              });
            });
          });
          tabs[0].click();
        }

        this.customSize = null;
        this._isValidCustomSize = false;

        this.maxBothCompare = 48;

        this.bothCompare = ['length', 'width'];

        this.shipperMinSizes = {
          length: 3,
          width: 3,
          height: 3,
        };

        this.shipperMaxSizes = {
          length: 24,
          width: 24,
          height: 24,
        };

        this.mailerMinSizes = {
          length: 3,
          width: 2,
          height: 1,
        };

        this.mailerMaxSizes = {
          length: 24,
          width: 24,
          height: 8,
        };

        this.boxType = null;
        if (this.dataset.boxtype) {
          this.boxType = this.dataset.boxtype;
        }

        this.errorContainer = this.querySelector('.message-error');

        this.selectedSizeText = this.querySelector('.selected-text');
        this.selectedSizeOpenText = this.querySelector('.selected-open-text');

        this.saveButton = this.querySelector('.save-custom-size');
        if (this.saveButton) {
          this.saveButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.save();
          });
        }

        if (this.form) {
          this.form.reset();
          this.form.addEventListener('submit', (e) => {
            e.preventDefault();

            this.save();
          });

          this.allInputs = this.form.querySelectorAll('input');
          if (this.allInputs && this.allInputs.length > 0) {
            Array.from(this.allInputs).forEach((input) => {
              input.addEventListener('input', () => {
                this.validateForm();
                this.save();
              });
            });
          }

          this.lengthInput = this.form.querySelector('input[name="length"]');
          this.widthInput = this.form.querySelector('input[name="width"]');
          this.heightInput = this.form.querySelector('input[name="height"]');
        }
      }

      set isValidCustomSize(value) {
        if (this.saveButton) this.saveButton.classList.remove('button-disable');
        if (!value && this.saveButton) this.saveButton.classList.add('button-disable');

        this._isValidCustomSize = value;
      }

      get isValidCustomSize() {
        return this._isValidCustomSize;
      }

      async connectedCallback() {
        await customElements.whenDefined('variant-selects');
        await customElements.whenDefined('design-online');
        if(this.designOnline && this.designOnline) this.designOnline.check();
      }



      save() {
        if (!this.customSize || !this.isValidCustomSize) return;

        this.form.classList.add('disabled');

        const {length, width, height} = this.customSize;

        // const sizeHtml = `<b> ${length} </b> x <b> ${width} </b> x <b> ${height} </b>`;

        // if (this.selectedSizeText) {
        //   this.selectedSizeText.innerHTML = sizeHtml;
        // }

        // if (this.selectedSizeOpenText) {
        //   this.selectedSizeOpenText.innerHTML = sizeHtml;
        // }

        this.dataset.value = 'custom';
        this.dataset.customValue = `${length}x${width}x${height}`;
        if (this.closest('size-dropdown')) {
          this.closest('size-dropdown').close();
        }
        this.dispatchEvent(new Event('change', {bubbles: true}));
      }

      validateForm() {
        let tempSize = {
          length: null,
          width: null,
          height: null,
        };

        // Check if all inputs are valid
        const isValidInputs = Array.from(this.allInputs).map((input) => {
          let isValid = false;

          // Get input type
          const type = input.getAttribute('name');

          // Trim input value
          input.value = input.value.trim();

          // Check if input is empty
          if (input.value != '') {
            // Remove all non numeric characters
            input.value = input.value.replace(/[^\d+(\.\d+)?)$]/g, '');

            // Check if input is a valid number
            if (/^(\d+(\.\d+)?)$/.test(input.value)) {
              isValid = true;
              tempSize[type] = parseFloat(input.value);
            }
          }

          // Add or remove invalid class
          if (isValid) input.closest('.value').classList.remove('invalid');
          else input.closest('.value').classList.add('invalid');

          // Return if input is valid
          return isValid;
        });

        if (!isValidInputs.every((isValid) => isValid)) {
          this.customSize = null;
          this.isValidCustomSize = false;
          return;
        }

        const {length, width, height} = tempSize;

        // Check if dimensions are valid
        if (length != null && width != null && height != null) {
          let errorMessage = '';
          let tempValid = true;

          if (this.boxType == 'mailer' && !this.checkDimensions(tempSize, this.mailerMaxSizes)) {
            errorMessage = `max size of W=${this.mailerMaxSizes.width} L=${this.mailerMaxSizes.length} D=${this.mailerMaxSizes.height}`;
            tempValid = false;
          } else if (this.boxType == 'mailer' && !this.checkDimensions(tempSize, this.mailerMinSizes, 'min')) {
            errorMessage = `min size of W=${this.mailerMinSizes.width} L=${this.mailerMinSizes.length} D=${this.mailerMinSizes.height}`;
            tempValid = false;
          } else if (this.boxType == 'shipper' && !this.checkDimensions(tempSize, this.shipperMinSizes, 'min')) {
            errorMessage = `min size of W=${this.shipperMinSizes.width} L=${this.shipperMinSizes.length} D=${this.shipperMinSizes.height}`;
            tempValid = false;
          } else if (this.boxType == 'shipper' && !this.checkDimensions(tempSize, this.shipperMaxSizes)) {
            errorMessage = `max size of W=${this.shipperMaxSizes.width} L=${this.shipperMaxSizes.length} D=${this.shipperMaxSizes.height}`;
            tempValid = false;
          } else if (
            this.boxType == 'shipper' &&
            !this.bothDimensions(tempSize, this.bothCompare, this.maxBothCompare)
          ) {
            errorMessage = `Length and Width combined cannot exceed 48 inches`;
            tempValid = false;
          } else if (this.boxType == 'mailer' && (height > length || height > width)) {
            this.heightInput.closest('.value').classList.add('invalid');
            errorMessage = 'Box Height cannot be greater than the Length or the Width';
            tempValid = false;
          }

          if (!tempValid) {
            this.customSize = null;
          }
          this.isValidCustomSize = tempValid;
        }

        if (!this.isValidCustomSize) {
          this.customSize = null;
          return;
        }

        this.customSize = tempSize;
      }

      bothDimensions(customSize, dimensions, limit) {
        let isValidSize = true;
        let sum = 0;
        for (const key in customSize) {
          if (dimensions.includes(key)) {
            sum += customSize[key];
          }
        }
        if (sum > limit) {
          isValidSize = false;
          for (const key in customSize) {
            const inputKey = `${key}Input`;
            this[inputKey].closest('.value').classList.add('invalid');
          }
        }
        return isValidSize;
      }

      checkDimensions(customSize, limitSizes, mode = 'max') {
        let isValidSize = true;

        for (const key in customSize) {
          let isValidDimension = false;

          if (mode == 'max') isValidDimension = customSize[key] <= limitSizes[key];
          else isValidDimension = customSize[key] >= limitSizes[key];

          if (isValidDimension)
            this.form.querySelector(`[name="${key}"]`).closest('.value').classList.remove('invalid');
          else {
            isValidSize = false;
            this.form.querySelector(`[name="${key}"]`).closest('.value').classList.add('invalid');
          }
        }

        return isValidSize;
      }
    },
  );
}

if (!customElements.get('size-dropdown-select')) {
  customElements.define(
    'size-dropdown-select',
    class sizeSelectV extends customSelect {
      constructor() {
        super();

        const fakeSelect = document.querySelector('.fake-select');
        const tabs = document.querySelectorAll('.content-tab-size');
        const contentTabs = document.querySelectorAll('.material-size');
        const fakeSelectedOption = this.querySelector('.fake-selected-option span');
        const fakeSelectedOptionContainer = this.querySelector('.fake-selected-option');
        const firstOptionShow = this.querySelector('.first-option-show');
        const fakeAvailableOptions = this.querySelector('.fake-available-options'); // Added this line

        this.form = this.querySelector('form.custom-size');
        this.designOnline = document.querySelector('design-online');
        this.VariantSelects = document.querySelector('variant-selects');



        fakeSelectedOptionContainer.addEventListener('click', () => {
          fakeAvailableOptions.style.display = (fakeAvailableOptions.style.display === 'none') ? 'block' : 'none';
        });

        // Hide fake-available-options when clicking outside the dropdown
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) {
            fakeAvailableOptions.style.display = 'none';
          }
        });

        if (tabs.length > 0 && firstOptionShow) {
          const activeTab = document.querySelector('.content-tab-size.active');
          if (activeTab) {
            firstOptionShow.textContent = activeTab.textContent.trim();
          }
        }


        if (tabs.length > 0) {
          tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
              e.preventDefault();
              fakeAvailableOptions.style.display = 'none';
              if (tab.classList.contains('active')) return;
              tabs.forEach((tab) => {
                tab.classList.remove('active');
              });
              tab.classList.add('active');
              contentTabs.forEach((contentTab) => {

                // contentTabs[contentTab].classList.add('active')

                if (contentTab.classList.contains('active')) {
                  contentTab.classList.remove('active');
                } else {
                  contentTab.classList.add('active');
                }

                if (tab.dataset.type == 'custom') {
                  this.designOnline.classList.toggle('button-disable', !this.isValidCustomSize);
                  this.dataset.value = 'custom';
                } else {
                  this.designOnline.classList.toggle('button-disable', false);
                  this.dataset.value = this.querySelector('[aria-selected="true"]').dataset.value;
                }

                if (this.VariantSelects) this.VariantSelects.onVariantChange();
              });

              // Obtener el texto de la pestaña activa
              const activeTabText = document.querySelector('.content-tab-size.active').textContent;
              // Establecer el texto en el span dentro de first-option-show
              document.querySelector('.fake-selected-option .first-option-show').textContent = activeTabText;
              console.log("tes")

            });
          });
        }

        this.customSize = null;
        this._isValidCustomSize = false;

                // Agregar evento change al dropdown
        const dropdown = this.querySelector('.selectCustom-options');
        dropdown.addEventListener('change', (event) => {
          const selectedIndex = event.target.selectedIndex;
          const selectedContent = contentTabs[selectedIndex];

          fakeSelectedOption.innerText = tabs[selectedIndex].innerText;

          contentTabs.forEach((contentTab) => {
            contentTab.style.display = 'none';
          });

          selectedContent.style.display = 'block';
        });

        this.maxBothCompare = 48;

        this.bothCompare = ['length', 'width'];

        this.shipperMinSizes = {
          length: 3,
          width: 3,
          height: 3,
        };

        this.shipperMaxSizes = {
          length: 31,
          width: 31,
          height: 31,
        };

        this.mailerMinSizes = {
          length: 3,
          width: 2,
          height: 1,
        };

        this.mailerMaxSizes = {
          length: 24,
          width: 24,
          height: 8,
        };

        this.boxType = null;
        if (this.dataset.boxtype) {
          this.boxType = this.dataset.boxtype;
        }

        this.errorContainer = this.querySelector('.message-error');

        // this.selectedSizeText = this.querySelector('.selected-text');
        // this.selectedSizeOpenText = this.querySelector('.selected-open-text');

        this.saveButton = this.querySelector('.save-custom-size');
        if (this.saveButton) {
          this.saveButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.save();
          });
        }

        if (this.form) {
          this.form.reset();
          this.form.addEventListener('submit', (e) => {
            e.preventDefault();

            this.save();
          });

          this.allInputs = this.form.querySelectorAll('input');
          if (this.allInputs && this.allInputs.length > 0) {
            Array.from(this.allInputs).forEach((input) => {
              input.addEventListener('input', () => {
                this.validateForm();
                this.save();
              });
            });
          }

          this.lengthInput = this.form.querySelector('input[name="length"]');
          this.widthInput = this.form.querySelector('input[name="width"]');
          this.heightInput = this.form.querySelector('input[name="height"]');
        }
      }

      set isValidCustomSize(value) {
        if (this.saveButton) this.saveButton.classList.remove('button-disable');
        if (!value && this.saveButton) this.saveButton.classList.add('button-disable');

        this._isValidCustomSize = value;
      }

      get isValidCustomSize() {
        return this._isValidCustomSize;
      }

      save() {
        if (!this.customSize || !this.isValidCustomSize) return;

        this.form.classList.add('disabled');

        const {length, width, height} = this.customSize;

        const sizeHtml = `<b> ${length} </b> x <b> ${width} </b> x <b> ${height} </b>`;

        if (this.selectedSizeText) {
          this.selectedSizeText.innerHTML = sizeHtml;
        }

        if (this.selectedSizeOpenText) {
          this.selectedSizeOpenText.innerHTML = sizeHtml;
        }

        this.dataset.value = 'custom';
        this.dataset.customValue = `${length}x${width}x${height}`;
        if (this.closest('size-dropdown')) {
          this.closest('size-dropdown').close();
        }
        this.dispatchEvent(new Event('change', {bubbles: true}));
      }

      validateForm() {
        let tempSize = {
          length: null,
          width: null,
          height: null,
        };

        // Check if all inputs are valid
        const isValidInputs = Array.from(this.allInputs).map((input) => {
          let isValid = false;

          // Get input type
          const type = input.getAttribute('name');

          // Trim input value
          input.value = input.value.trim();

          // Check if input is empty
          if (input.value != '') {
            // Remove all non numeric characters
            input.value = input.value.replace(/[^\d+(\.\d+)?)$]/g, '');

            // Check if input is a valid number
            if (/^(\d+(\.\d+)?)$/.test(input.value)) {
              isValid = true;
              tempSize[type] = parseFloat(input.value);
            }
          }

          // Add or remove invalid class
          if (isValid) input.closest('.value').classList.remove('invalid');
          else input.closest('.value').classList.add('invalid');

          // Return if input is valid
          return isValid;
        });

        if (!isValidInputs.every((isValid) => isValid)) {
          this.customSize = null;
          this.isValidCustomSize = false;
          return;
        }

        const {length, width, height} = tempSize;

        // Check if dimensions are valid
        if (length != null && width != null && height != null) {
          let errorMessage = '';
          let tempValid = true;

          if (this.boxType == 'mailer' && !this.checkDimensions(tempSize, this.mailerMaxSizes)) {
            errorMessage = `max size of W=${this.mailerMaxSizes.width} L=${this.mailerMaxSizes.length} D=${this.mailerMaxSizes.height}`;
            tempValid = false;
          } else if (this.boxType == 'mailer' && !this.checkDimensions(tempSize, this.mailerMinSizes, 'min')) {
            errorMessage = `min size of W=${this.mailerMinSizes.width} L=${this.mailerMinSizes.length} D=${this.mailerMinSizes.height}`;
            tempValid = false;
          } else if (this.boxType == 'shipper' && !this.checkDimensions(tempSize, this.shipperMinSizes, 'min')) {
            errorMessage = `min size of W=${this.shipperMinSizes.width} L=${this.shipperMinSizes.length} D=${this.shipperMinSizes.height}`;
            tempValid = false;
          } else if (this.boxType == 'shipper' && !this.checkDimensions(tempSize, this.shipperMaxSizes)) {
            errorMessage = `max size of W=${this.shipperMaxSizes.width} L=${this.shipperMaxSizes.length} D=${this.shipperMaxSizes.height}`;
            tempValid = false;
          } else if (
            this.boxType == 'shipper' &&
            !this.bothDimensions(tempSize, this.bothCompare, this.maxBothCompare)
          ) {
            errorMessage = `Length and Width combined cannot exceed 48 inches`;
            tempValid = false;
          } else if (this.boxType == 'mailer' && (height > length || height > width)) {
            this.heightInput.closest('.value').classList.add('invalid');
            errorMessage = 'Box Height cannot be greater than the Length or the Width';
            tempValid = false;
          }

          if (!tempValid) {
            this.customSize = null;
          }
          this.isValidCustomSize = tempValid;
        }

        if (!this.isValidCustomSize) {
          this.customSize = null;
          return;
        }

        this.customSize = tempSize;
      }

      bothDimensions(customSize, dimensions, limit) {
        let isValidSize = true;
        let sum = 0;
        for (const key in customSize) {
          if (dimensions.includes(key)) {
            sum += customSize[key];
          }
        }
        if (sum > limit) {
          isValidSize = false;
          for (const key in customSize) {
            const inputKey = `${key}Input`;
            this[inputKey].closest('.value').classList.add('invalid');
          }
        }
        return isValidSize;
      }

      checkDimensions(customSize, limitSizes, mode = 'max') {
        let isValidSize = true;

        for (const key in customSize) {
          let isValidDimension = false;

          if (mode == 'max') isValidDimension = customSize[key] <= limitSizes[key];
          else isValidDimension = customSize[key] >= limitSizes[key];

          if (isValidDimension)
            this.form.querySelector(`[name="${key}"]`).closest('.value').classList.remove('invalid');
          else {
            isValidSize = false;
            this.form.querySelector(`[name="${key}"]`).closest('.value').classList.add('invalid');
          }
        }

        return isValidSize;
      }
    },
  );
}


if (!customElements.get('quantity-type')) {
  customElements.define(
    'quantity-type',
    class quantityType extends HTMLElement {
      constructor() {
        super();

        this.dropdownQty = document.querySelector('quantity-dropdown');
        this.dropdownPackage = document.querySelector('package-dropdown');

        this.buttonsRadio = this.querySelectorAll('.buttonRadio');
        if (this.buttonsRadio.length > 0) {
          this.buttonsRadio.forEach((button) => {
            button.addEventListener('click', (e) => {
              if (button.classList.contains('selected')) return;

              this.unselectAllButtons();

              button.classList.add('selected');

              this.changeType(e);
            });

            if (button.dataset.value === 'package') button.click();
          });
        }
      }

      unselectAllButtons() {
        this.buttonsRadio.forEach((button) => {
          button.classList.remove('selected');
        });
      }

      changeType(e) {
        e.preventDefault();

        this.dataset.value = e.currentTarget.dataset.value;

        if (this.dataset.value == 'unit') {
          if( this.dropdownPackage){
            this.dropdownPackage.classList.add('hidden');
          }
          if(this.dropdownQty){
            this.dropdownQty.setFirstAvailableOption();
            this.dropdownQty.classList.remove('hidden');
            this.dropdownQty.triggerEvent();
          }
        } else {
          if(this.dropdownQty) {
            this.dropdownQty.classList.add('hidden');
          }
          if(this.dropdownPackage){
            this.dropdownPackage.setFirstAvailableOption();
            this.dropdownPackage.classList.remove('hidden');
            this.dropdownPackage.triggerEvent();
          }
        }
      }
    },
  );
}
